module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-300.c87db941.woff2";